import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageContext';
import Header from './components/Header';
import Hero from './components/Hero';
import WhyBali from './components/WhyBali';
import ProjectShowcase from './components/ProjectShowcase';
import Services from './components/Services';
import Testimonials from './components/Testimonials';
import Journey from './components/Journey';
import Contact from './components/Contact';
import Footer from './components/Footer';
import ChatBot from './components/ChatBot';
import LandingImmo from './pages/LandingImmo';
import AdminLeads from './pages/AdminLeads';
import './index.css';

// Main website component
function MainSite() {
  const [isChatOpen, setIsChatOpen] = useState(false);

  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <LanguageProvider>
      <div className="min-h-screen bg-[#0B0E11]">
        <Header onNavigate={scrollTo} />
        
        <main>
          <Hero onNavigate={scrollTo} onOpenChat={() => setIsChatOpen(true)} />
          <WhyBali />
          <ProjectShowcase />
          <Services />
          <Journey />
          <Testimonials />
          <Contact />
        </main>
        
        <Footer onNavigate={scrollTo} />
        
        <ChatBot isOpen={isChatOpen} onClose={() => setIsChatOpen(false)} onOpen={() => setIsChatOpen(true)} />
      </div>
    </LanguageProvider>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainSite />} />
        <Route path="/immo" element={<LandingImmo />} />
        <Route path="/investir" element={<LandingImmo />} />
        <Route path="/instagram" element={<LandingImmo />} />
        <Route path="/admin/leads" element={<AdminLeads />} />
      </Routes>
    </Router>
  );
}

export default App;
